import { Component, Inject, Input, OnInit } from '@angular/core';
import { QueuesService } from '@app/_core/services/queues.service';
import { UserService } from '@app/_core/services/user.service';
import { BsModalRef,BsModalService,ModalOptions } from 'ngx-bootstrap/modal';
import { SearchDialogComponent } from '@app/_shared/components';
import { EmailSuccessPopupComponent } from '../email-success-popup/email-success-popup.component';
import { ViewEncapsulation } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
@Component({
  selector: 'app-compose-mail',
  templateUrl: './compose-mail.component.html',
  styleUrls: ['./compose-mail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ComposeMailComponent implements OnInit {
  @Input() Heading: any;
  @Input() reason: any;
  @Input() mode: 'compose' | 'reply' | 'replyAll' | 'forward' = 'compose';
  @Input() originalEmail: any = null;

  selectTo: any;
  isEmail = true;
  toArray: any = [];
  editorContent: string = '<p>Hello</p>';
  showBcc: boolean = false;
  bcc: string = '';
  subject: string = '';
  ccValue: string = '';
  fromAddress: string = '';
  sendEmailTimeout: any;
  constructor(
    public bsModalRef: BsModalRef,
    public queueService: QueuesService,
    private userService: UserService,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {
    this.queueService.notifyEmail.subscribe((emails) => {
      if (Array.isArray(emails)) {
        this.toArray = [...emails];
      }
    });
  }

  ngOnInit(): void {
    this.selectTo = false;
    this.toArray = this.queueService.toGetEmailArrayFunction();
    this.fromAddress = this.userService.currentUserValue?.Email || '';
    this.prepareCompose();
  }

  private prepareCompose(): void {
    if (!this.originalEmail || this.mode === 'compose') return;

    const isForward = this.mode === 'forward';
    const prefix = isForward ? 'Fwd: ' : 'Re: ';
    this.subject = prefix + (this.originalEmail.Subject || '');

    if (this.mode === 'reply') {
      this.toArray = [{ Email: this.originalEmail.From }];
    } else if (this.mode === 'replyAll') {
      const fromAddr = [{ Email: this.originalEmail.From }];
      const toAddrs = (this.originalEmail.To || '')
        .split(/[;,]/)
        .map((a: string) => a.trim())
        .filter((a: string) => a)
        .map((addr: string) => ({ Email: addr }));
      this.toArray = [...fromAddr, ...toAddrs];
      this.ccValue = this.originalEmail.CC || '';
    }
    // forward: toArray stays empty — user fills in the recipient

    const quotedBody = this.buildQuotedBody();
    this.editorContent = `<br/><br/>${quotedBody}`;
  }

  private buildQuotedBody(): string {
    const from = this.originalEmail.From || '';
    const date = this.originalEmail.ReceivedDate || '';
    const subject = this.originalEmail.Subject || '';
    const body = this.originalEmail.Body || '';
    return `<hr/><p><strong>From:</strong> ${from}</p>` +
           `<p><strong>Date:</strong> ${date}</p>` +
           `<p><strong>Subject:</strong> ${subject}</p><br/>${body}`;
  }
  goToAddRecipants() {
    this.selectTo = !this.selectTo;
    this.Heading = 'Add Recipants';
    this.queueService.setEmailComposeTo(true);
  }

  closeTaskSelectionMenu() {
    this.queueService.setEmailComposeTo(false);
    this.bsModalRef.hide();
  }
  removeEmails(data) {
    this.queueService.toSubEmailArrayFunction(data);
  }
  addEmails() {
    this.toArray = this.queueService.toGetEmailArrayFunction();
    this.selectTo = false;
    this.Heading = 'Compose Mail';
    this.queueService.setEmailComposeTo(false);
  }
  editorContentHandler(content: any) {
    this.editorContent = content;
  }
  sendEmail() {
    this.bsModalRef.onHidden?.subscribe(() => {
      const successRef = this.modalService.show(EmailSuccessPopupComponent, {
        class: 'modal-dialog-centered',
        backdrop: 'static',
      });
      this.sendEmailTimeout = setTimeout(() => successRef.hide(), 3000);
    });
    this.bsModalRef.hide();
  }
  toggleBcc() {
    this.showBcc = !this.showBcc;
  }
  getEmail(item: any): string {
    return item?.Email ||
      item?.SearchableFieldResponses
        ?.find((x: any) => x.FieldName === 'Email:')
        ?.Values?.[0] ||
      '';
  }
  ngOnDestroy(): void {
    this.sendEmailTimeout && clearTimeout(this.sendEmailTimeout);
  }
}
